<template>
	<div class="content">
		<headerTop value="2"></headerTop>
		<div class="center page-contents" :style="{animation:animation}">
			<div class="child flexleft" :class="'animation-from-right-'+index" v-for="(item,index) in list" :key="index"
				@click="todetail(item.url)">
				<div class="left">
					<img :src="$index.addurl(item.thumb_url)" alt="">
				</div>
				<div class="right">
					<div class="title">{{item.title}}</div>
					<div class="content">{{item.digest}}</div>
					<div class="time">发布时间 : {{item.create_time}}</div>
				</div>
			</div>
			<div class="page">
				<el-pagination :hide-on-single-page="value" :current-page="currentPage" :page-size="15"
					@current-change="addPage" layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				animation: '',
				value: true,
				currentPage: 1, //分页当前页数
				total: 10,
				currentPage: 1,
				list: [],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getlist();
		},
		methods: {
			todetail(url) {
				window.open(url);
			},
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
				var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
				var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
				var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				return Y + M + D + h + m + s;
			},
			addPage(e) {
				this.currentPage = e;
				this.getlist();
			},
			getlist() {
				let _this = this;
				_this.$api.user.weixin_news({
					page: _this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						_this.total = res.data.total;
						res.data.data.forEach(item => {
							item.create_time = _this.timestampToTime(item.create_time);
						})
						_this.list = res.data.data;
					}
				})
			},
		},

	}
</script>
<style scoped lang="scss">
	.page {
		margin: auto;
		display: flex;
		justify-content: center;
	}

	.center {
		margin: 200px auto;
	}

	.child:hover {
		box-shadow: 0px 0px 20px 4px #eee;
	}

	.child {
		cursor: pointer;
		width: 100%;
		transition: all .3s ease-in-out;
		background-color: #eee;
		border-radius: 10px;
		height: 200px;
		margin: 30px 0;

		.right {
			padding: 30px;
			display: flex;
			flex-direction: column;

			.title {
				font-size: 30px;
				color: #111;
				display: -webkit-box;
				overflow: hidden;
				/*! autoprefixer: off; */
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
			}

			.content {
				font-size: 20px;
				color: #999;
				margin: 10px 0 20px;
				min-height: 60px;
				display: -webkit-box;
				overflow: hidden;
				/*! autoprefixer: off; */
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
			}

			.time {
				font-size: 14px;
				color: #666;
			}

		}

		.left {
			min-width: 300px;
			max-width: 300px;
			height: 200px;

			img {
				object-fit: cover;
				border-radius: 10px 0 0 10px;
				width: 100%;
				height: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// ctRibao.vue?48391763